import React from "react";

export const AppTerms = () => (
    <iframe
        src="https://www.well-b.biz/terms-and-conditions"
        frameBorder="0"
        allowFullScreen="false"
        allowTransparency="true"
        width="100%"
        height="100%"
        marginHeight="0"
        marginWidth="0"
        style={{position: "absolute", left: 0, top: 0, width: "100%", height: "100%"}}
    />
);
